import { render, staticRenderFns } from "./RegisterEventIndex.vue?vue&type=template&id=d7a5b008&"
import script from "./RegisterEventIndex.vue?vue&type=script&lang=js&"
export * from "./RegisterEventIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports